import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Badge } from '../components/ui/badge';
import { CalendarDays, ArrowRight, BookOpen } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then(r => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[var(--cream)]" data-testid="blog-page">
      <div className="bg-white border-b border-[var(--sage)]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--dark)] mb-2">Blog</h1>
          <p className="text-base text-[var(--dark)]/50">Articulos sobre skincare coreano y tendencias de belleza</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {posts.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map(post => (
              <Link key={post.id} to={`/blog/${post.id}`} className="group bg-white rounded-2xl overflow-hidden border border-[var(--sage)]/20 hover:shadow-lg transition-all" data-testid={`blog-card-${post.id}`}>
                {post.image && (
                  <div className="h-48 overflow-hidden">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                )}
                <div className="p-5 space-y-3">
                  <Badge className="bg-[var(--sage-light)] text-[var(--sage-dark)] border-0 text-xs">{post.category || 'General'}</Badge>
                  <h3 className="text-lg font-bold text-[var(--dark)] group-hover:text-[var(--violet)] transition-colors">{post.title}</h3>
                  <p className="text-sm text-[var(--dark)]/50 line-clamp-2">{post.excerpt}</p>
                  <div className="flex items-center justify-between pt-2">
                    <div className="flex items-center gap-1.5 text-xs text-[var(--dark)]/30">
                      <CalendarDays className="h-3 w-3" />
                      {new Date(post.created_at).toLocaleDateString('es-ES')}
                    </div>
                    <span className="text-sm text-[var(--violet)] font-medium flex items-center gap-1">
                      Leer <ArrowRight className="h-3 w-3" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <BookOpen className="h-12 w-12 text-[var(--dark)]/20 mx-auto mb-4" />
            <p className="text-lg text-[var(--dark)]/40">Articulos proximamente</p>
          </div>
        )}
      </div>
    </div>
  );
}
